import { DefectSummaryDataItem } from "../../types/DefectSummaryDataItem";
import { DefectTabs } from "../../types/DefectTabs";
import { FilterMatchMode } from "primereact/api";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { setActiveTab } from "../../store/slices/defectSlice";
import { resetTableFilters } from "../../store/thunks/filtersThunks";
import { selectIsTechManager } from "../../store/selectors/userSelectors";
import { getSummaryTableLinkConfig } from "../../utils/DefectsSummaryTableDataHelper";

type DefectSummaryTotalDefectsLinkProps = {
    rowData: DefectSummaryDataItem
} 

export const DefectSummaryTotalDefectsLink = (props: DefectSummaryTotalDefectsLinkProps) => {
    const { rowData } = props;
    const isTechManager = useAppSelector(selectIsTechManager);
    const dispatch = useAppDispatch();

    const { tableKey, defaultConfig, nameField, statusField } = getSummaryTableLinkConfig(isTechManager);

    const navigateToDefectsTab = () => {
        dispatch(resetTableFilters(tableKey, {
            ...defaultConfig,
            [nameField]: { value: rowData.vesselName, matchMode: FilterMatchMode.CONTAINS },
            [statusField]: { value: [], matchMode: FilterMatchMode.IN },
        }));
        dispatch(setActiveTab(DefectTabs.defects));
    }

    return (
        <button className="font-semibold underline cursor-pointer read-more-btn total-defect-btn" onClick={navigateToDefectsTab}>
            {rowData.totalDefects}
        </button>
    );
};
